import classNames from "classnames";
import { FC } from "react";
import { Button } from "../button/button";
import { StyledSwitchWrap } from "./style";

interface IProps {
    isDisabled?: boolean;
    state: "on" | "off";
    onSwitch: (state: boolean) => void;
}
const SimpleSwitch: FC<IProps> = ({ state, onSwitch, isDisabled }) => {
    const onSwitchBtn = () => {
        if (state === "on") {
            onSwitch(false);
        } else onSwitch(true);
    };
    return (
        <StyledSwitchWrap className="switchContainer" onClick={onSwitchBtn}>
            <Button
                color="light"
                className={classNames({
                    on: state === "on",
                    off: state === "off",
                    disabled: isDisabled,
                })}
            >
                <span className="pin" />
            </Button>
        </StyledSwitchWrap>
    );
};

export default SimpleSwitch;
